class LineItemIconDelete extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initRemoveButton();
  }

  initRemoveButton() {
    this.querySelector('#remove-button').addEventListener('click', ()=> {
      // Trigger click on another button
      this.querySelector('a.link').click();
    });
  }

}

customElements.define("line-item-icon-delete", LineItemIconDelete);


import {LineItemQuantity} from "//rubor.be/cdn/shop/t/4/assets/theme.js?v=120143994335757986961709470819"; // Import the theme web component
class LineItemQuantityWithButtons extends LineItemQuantity {
  connectedCallback() {
    this.inputElement = this.querySelector("input");
    this.querySelector("button:first-of-type").addEventListener("click", (e) => {
      this.inputElement.quantity = this.inputElement.quantity - 1;
      this._changeLineItemQuantity(this.inputElement.getAttribute("data-line-key"), parseInt(this.inputElement.quantity));
    });
    this.querySelector("button:last-of-type").addEventListener("click", (e) => {
      this.inputElement.quantity = this.inputElement.quantity + 1;
      this._changeLineItemQuantity(this.inputElement.getAttribute("data-line-key"), parseInt(this.inputElement.quantity));
    });
  }

  constructor() {
    super();
  }
}
window.customElements.define('line-item-quantity-with-buttons', LineItemQuantityWithButtons);



// js/sections/image-link-blocks.js
import { ScrollArea,Drawer,formatMoney,CustomButton } from "//rubor.be/cdn/shop/t/4/assets/theme.js?v=120143994335757986961709470819";
var InstaFeedBlocks = class extends HTMLElement {
  connectedCallback() {
    const observer = new MutationObserver((mutationsList, observer) => {
      for(let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          this.items = Array.from(this.querySelectorAll("a"));
          if (this.items.length > 0) {
            // Remove the first div but keep its content
            let firstDiv = this.querySelector('div');
            if (firstDiv) {
              let content = firstDiv.innerHTML;
              this.innerHTML = content;
              new ScrollArea(this);
              this.addEventListener("control:prev", this._prev);
              this.addEventListener("control:next", this._next);
              observer.disconnect(); // Stop observing when we have our 'a' tags
              break;
            }
          }
        }
      }
    });

    // Start observing the document with the configured parameters
    observer.observe(this, { childList: true, subtree: true });
  }

  _prev() {
    this.scrollBy({ left: (document.dir === "rtl" ? 1 : -1) * this.items[0].clientWidth, behavior: "smooth" });
  }
  _next() {
    this.scrollBy({ left: (document.dir === "rtl" ? -1 : 1) * this.items[0].clientWidth, behavior: "smooth" });
  }
};
window.customElements.define("insta-feed-blocks", InstaFeedBlocks);
// js/common/facets/facet-link.js
var FacetLinkV2 = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this._onFacetUpdate);
  }
  _onFacetUpdate(event) {
    event.preventDefault();
    const sectionId = event.target.closest(".shopify-section").id.replace("shopify-section-", ""), url = new URL(this.href);
    url.searchParams.set("section_id", sectionId);
    this.dispatchEvent(new CustomEvent("facet:putnew", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};

if (!window.customElements.get("facet-link-v2")) {
  window.customElements.define("facet-link-v2", FacetLinkV2, { extends: "a" });
}


class PosMap extends HTMLElement {
  connectedCallback() {
    mapboxgl.accessToken = 'pk.eyJ1Ijoia211bm96IiwiYSI6ImNsY3A3NDloaDA2bnozcGxiN2U1Y2I2bWIifQ.WY4_mVStBm5c9CjvWsVy3w';
    const firstPosItem = document.querySelector('.pos-item');
    const posData = JSON.parse(firstPosItem.dataset.posItem);

    const map = new mapboxgl.Map({
      container: this.querySelector('#map'),
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [posData.latitude,posData.longitude],
      zoom: posData.zoom
    });

    // Create a new marker and add it to the map
    new mapboxgl.Marker()
      .setLngLat([posData.latitude, posData.longitude])
      .addTo(map);

    document.addEventListener('posItemSelected', (event) => {
      const posData = event.detail;
      map.flyTo({
        center: [posData.latitude,posData.longitude],
        zoom: posData.zoom,
        bearing: 20,
        pitch: 45,
        duration: 2000
      });

      // Remove all existing markers
      document.querySelectorAll('.mapboxgl-marker').forEach(marker => marker.remove());

      // Add a new marker at the new location
      new mapboxgl.Marker()
        .setLngLat([posData.latitude, posData.longitude])
        .addTo(map);
    });
  }
}

class PosLists extends HTMLElement {
  connectedCallback() {
    // Add a click event listener to each .pos-item element
    this.querySelectorAll('.pos-item').forEach(item => {
      item.addEventListener('click', () => {
        // When a .pos-item is clicked, dispatch a custom event with the item's data
        const posData = JSON.parse(item.dataset.posItem);
        document.dispatchEvent(new CustomEvent('posItemSelected', { detail: posData }));
      });
    });

      // Add an input event listener to the search input field
    const searchInput = this.querySelector('#pos-main-search');
    searchInput.addEventListener('input', () => {
      const searchValue = searchInput.value.toLowerCase();

      // Filter the .pos-item elements based on the input value
      this.querySelectorAll('.pos-item').forEach(item => {
        const itemTitle = item.querySelector('.pos-item-title').textContent.toLowerCase();
        const itemAddress = item.querySelector('.pos-item-address').textContent.toLowerCase();
        const itemCity = item.querySelector('.pos-item-city').textContent.toLowerCase();

        if (itemTitle.includes(searchValue) || itemAddress.includes(searchValue) || itemCity.includes(searchValue)) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
  }
}

// js/common/search/search-drawer.js
var StarterSetDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches ? "top" : this.getAttribute("open-from") || "right";
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('recharge:node', this.importNode);
  }

  importNode(event) {
    const eventListenters = (id) => {
      const productDivs = this.querySelectorAll('.horizontal-product');
      productDivs.forEach((div,i) => {
        const addButton = div.querySelector('[is="trig-add-product"]');
        if (addButton) {
          addButton.addEventListener('click', ()=>{
            let button = document.querySelector(`#${id} .cart-drawer__inner .horizontal-product[starter-set-item-id='${div.getAttribute('starter-set-item-id')}'] [is='trig-add-product']`);

            // Create a new custom event
            let event = new CustomEvent('fk:click');

            // Dispatch the event
            button.dispatchEvent(event);
          });
        }
      });

      productDivs.forEach((div,i) => {
        const addButton = div.querySelector('[is="product-added"]');
        if (addButton) {
          addButton.addEventListener('click', ()=>{
            let button = document.querySelector(`#${id} .cart-drawer__inner .horizontal-product[starter-set-item-id='${div.getAttribute('starter-set-item-id')}'] [is='product-added']`);

            // Create a new custom event
            let event = new CustomEvent('fk:click');

            // Dispatch the event
            button.dispatchEvent(event);
          });
        }
      });
    }
    
    let drawerInner = document.querySelector('startset-drawer .cart-drawer__inner');
    drawerInner.innerHTML = '';
    if (drawerInner && event.detail.nodeItems) {
      event.detail.nodeItems.forEach(node => {
        drawerInner.appendChild(node.cloneNode(true));
      });
    } 
    eventListenters(event.detail.parentNode);
  }



};
if (!window.customElements.get("startset-drawer")) {
  window.customElements.define("startset-drawer", StarterSetDrawer);
}

var CustomButtonV2 = class extends CustomButton {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  constructor() {
    super();
    this.append(this.contentElement, this.animationElement);
    //window.addEventListener("pageshow", () => this.removeAttribute("aria-busy"));
  }

  
};
if (!window.customElements.get("trig-atc")) {
  window.customElements.define("trig-atc", CustomButtonV2, { extends: "button" });
}

class PosMain extends HTMLElement {
  connectedCallback() {
    // Any initialization code for pos-main goes here...
  }
}

class PosListContainer extends HTMLElement {
  connectedCallback() {
    // Any initialization code for pos-list-container goes here...
  }
}

let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

class StarterSet extends HTMLElement {
  constructor() {
    super();
    this.productId= this.getAttribute('product-id');
    this.starterSetCount = this.getAttribute('data-starter-set-size');
    this.startSetItems = Array.from({length: this.starterSetCount}, () => ({selectedProduct: null}));
    this.startSetAmount = 0;
    this.priceElement = this.querySelector('h6[is="data-starter-price"]');
    this.selectionBlocks = this.querySelectorAll('div[js-starter-selection-block]');
    this.atcButton = this.querySelector('button[is="trig-atc"]');
    this.xTabs = this.querySelector('x-tabs');
    this.currentIndex=null;
  }

  connectedCallback() {
    this.attachEventListeners();
    this.placeHolderProductsAttachListeners();
    this.changeButtonAttachListeners();
    this.atcButtonAddEventListener();
    this.imgPickerAttachListeners();
    this.attachRemoveEventListeners();
  }
  
  imgPickerAttachListeners() {
    this.selectionBlocks.forEach(block => {
      const button = block.querySelector('button[is="trig-add-placeholder"]');
      const img = block.querySelector('img.product-img-picker');
      img.addEventListener('click', button.click.bind(button));
    });
  }

  atcButtonAddEventListener() {
    this.atcButton.addEventListener('click',async () => {
      // Find the first element in this.startSetItems where selectedProduct is null
      const nextStepIndex = this.startSetItems.findIndex(item => item.selectedProduct === null);

      // If such an element not found, so att products to the cart
      if (nextStepIndex === -1) {
        this.atcButton.setAttribute("disabled", "disabled");
        this.atcButton.setAttribute("aria-busy", "true");
        let formData = {
          'items': [{
            'id': this.productId,
            'quantity': 1,
            'properties': {}
          }]
        };

        this.startSetItems.forEach((item, index) => {
          formData.items[0].properties[`design ${index + 1}`] = item.selectedProduct.title;
        });
        
         fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(async (response) => {
          const responseJson = await response.json();
    if (response.ok) {
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `/cart.js`;
      }
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));
      setTimeout(() => {
          FGSECOMAPP.renderPromotionMessage(FGSECOMAPP.offers);
      }, 500)
      this.atcButton.removeAttribute("disabled");
      this.atcButton.setAttribute("aria-busy", "false");
    } else {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
    }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
      else{
         // Create a custom event with some parameters
        
        let event = new CustomEvent('recharge:node', {
          detail: {
            parentNode:this.id,
            nodeItems: Array.from(this.querySelector('.starter-set-container .cart-drawer__inner')?.childNodes || [])
          }
        });
        // Dispatch the custom event
        document.dispatchEvent(event);

        //this.getToTab(nextStepIndex)
        document.querySelector('startset-drawer')?.setAttribute('open','');
      }
    });
  }

  attachRemoveEventListeners() {
    const productDivs = this.querySelectorAll('.starter-set-container .horizontal-product');
    productDivs.forEach((div,i) => {
      const addButton = div.querySelector('[is="product-added"]');
      if (addButton) {
        addButton.addEventListener('click', this.handleRemoveProduct.bind(this));
        addButton.addEventListener('fk:click', this.handleRemoveProduct.bind(this));
      }
    });
  }

  attachEventListeners() {
    const productDivs = this.querySelectorAll('.starter-set-container .horizontal-product');
    productDivs.forEach((div,i) => {
      const addButton = div.querySelector('[is="trig-add-product"]');
      if (addButton) {
        addButton.addEventListener('click', this.handleAddProduct.bind(this));
        addButton.addEventListener('fk:click', this.handleAddProduct.bind(this));
      }
    });
  }
  placeHolderProductsAttachListeners() {
    this.selectionBlocks.forEach(block => {
      const button = block.querySelector('button[is="trig-add-placeholder"]');
      button.addEventListener('click', this.getToTab.bind(this,0));
    });
  }

  changeButtonAttachListeners() {
    this.selectionBlocks.forEach((div,i) => {
      const changeButton = div.querySelector('[is="trig-change-product"]');
      if (changeButton) {
        changeButton.addEventListener('click', ()=>
        {
          this.currentIndex=i;
        });
      }
    });
  }
  getToTab(index) {
    this.xTabs?.setAttribute('selected-index', index);
     //recherge nodemodal
     document.dispatchEvent(new CustomEvent('recharge:node', {
        detail: {
          parentNode:this.id,
          nodeItems: Array.from(this.querySelector('.starter-set-container .cart-drawer__inner')?.childNodes || [])
        }
      })
      );
  }
  calculatePrice() {
    let total = 0;
    this.startSetItems.forEach(item => {
      if (item.selectedProduct) {
        total += item.selectedProduct.price;
      }
    });
    this.startSetAmount = total;

    this.priceElement.textContent = `${formatMoney(total, currencyFormat)}`;
  }

  handleRemoveProduct(event) {
    const productContainer = event.target.closest('.horizontal-product');
    const product = JSON.parse(productContainer.getAttribute('starter-set-product'));
    const productPosition = productContainer.getAttribute('starter-set-item-postion');
    //ensure that we are not in a change
    this.currentIndex=null;
    const productIndex = this.startSetItems.findIndex(item => (item.selectedProduct != null && item.selectedProduct.id === product.id));
    if (productIndex !== -1) {
      this.startSetItems[productIndex] = { selectedProduct: null };
      this.updateProductSelection(product, productIndex);
    }

      // Remove 'added' class from all product items
      const allItems = this.querySelectorAll(`.horizontal-product.drawer-starter-set`);
      allItems.forEach(item => item.classList.remove('added'));
      
      allItems.forEach(item => {
        // Get the product ID from the 'starter-set-product' attribute
        const productId = JSON.parse(item.getAttribute('starter-set-product')).id;

        // Check if the product ID is in the startSetItems array
        if (this.startSetItems.some(setItem => (setItem.selectedProduct != null && setItem.selectedProduct.id === productId))) {
          // If it is, add the 'added' class to the item
          item.classList.add('added');
        } 
      });
      // Add 'added' class to the product that was added
      //productContainer.classList.add('added');

      //recherge nodemodal
      this.getToTab(productPosition-1)
  }

    handleAddProduct(event) {
      const productContainer = event.target.closest('.horizontal-product');
      const product = JSON.parse(productContainer.getAttribute('starter-set-product'));
      const productPosition = productContainer.getAttribute('starter-set-item-postion');

      if(this.currentIndex!=null){
        //so it's a change we need to remove first the starter set item
        this.startSetItems[this.currentIndex] = { selectedProduct: null };
        this.currentIndex=null;
      }

      const nextStepIndex = this.startSetItems.findIndex(item => item.selectedProduct === null);
      // If such an element is found, set the current-step number in this.atcButton to the index of that element plus 1
      if (nextStepIndex !== -1) {
        this.startSetItems[nextStepIndex] = { selectedProduct: product };
        this.updateProductSelection(product, nextStepIndex);
      }
      else{
        this.startSetItems[this.startSetItems.length - 1] = { selectedProduct: product };   
        this.updateProductSelection(product, this.startSetItems.length - 1);
      }

      // Remove 'added' class from all product items
      const allItems = this.querySelectorAll(`.horizontal-product.drawer-starter-set`);
      allItems.forEach(item => item.classList.remove('added'));

      allItems.forEach(item => {
        // Get the product ID from the 'starter-set-product' attribute
        const productId = JSON.parse(item.getAttribute('starter-set-product')).id;

        // Check if the product ID is in the startSetItems array
        if (this.startSetItems.some(setItem => (setItem.selectedProduct != null && setItem.selectedProduct.id === productId))) {
          // If it is, add the 'added' class to the item
          item.classList.add('added');
        } 
      });
      // Add 'added' class to the product that was added
      //productContainer.classList.add('added');

      //recherge nodemodal
      this.getToTab(productPosition-1)
    }

    updateProductSelection(product, productPosition) {
      // Add 'selected' class to the selection block with the same data-set-index as productPosition
      this.startSetItems.forEach((item, index) => {
      const selectedBlock = Array.from(this.selectionBlocks).find(block => block.getAttribute('data-set-index') == ( index+1 ).toString());
        if (selectedBlock) {
          // Get the filled-product div, a tag, and img tag
          const filledProduct = selectedBlock.querySelector('.filled-product');
          const aTag = filledProduct.querySelector('a');
          const imgTag = filledProduct.querySelector('img.horizontal-product__image');

          // Change the title and href of the a tag and the src of the img tag
          if(item.selectedProduct!=null){
            aTag.textContent = item.selectedProduct.title;
            aTag.href = '/products/' + item.selectedProduct.handle;
            imgTag.src = item.selectedProduct.featured_image;
            imgTag.srcset = item.selectedProduct.featured_image;
            
            selectedBlock.classList.add('selected');
          }
          else{
            selectedBlock.classList.remove('selected');
          }
        }
      });

      // Update the price
      //this.calculatePrice();
      // Find the first element in this.startSetItems where selectedProduct is null
      const nextStepIndex = this.startSetItems.findIndex(item => item.selectedProduct === null);
      //this.getToTab(productPosition-1);

      // If such an element is found, set the current-step number in this.atcButton to the index of that element plus 1
      if (nextStepIndex !== -1) {
        debugger
        this.atcButton.querySelector('div').innerHTML=`${window.themeVariables.strings.choose_design} <span class="current-step">${nextStepIndex + 1}</span>`;
      }
      else{
        let divElement = this.atcButton.querySelector("div");
        if (divElement) {
          divElement.textContent = window.themeVariables.strings.addToCartButton;
        }     
      }
    }
}

customElements.define('starter-set', StarterSet);
customElements.define('pos-map', PosMap);
customElements.define('pos-lists', PosLists);
customElements.define('pos-main', PosMain);
customElements.define('pos-list-container', PosListContainer);